/**
 * The URL segment the scheduled-tasks screen lives at under the Clarity section: `/clarity/tasks`.
 *
 * Shared because three layers must agree on it — the application's route, the feature's own in-screen
 * navigation and the shell's user-menu link — and `type:util` is the one layer all three may reach.
 */
export const CLARITY_TASKS_ROUTE_SEGMENT = 'tasks';
